import StringHelperService from 'services/string-helper.service';
import FormConstants from '../../constants/form/form.constants';
import AutoCompleteServiceData from './AutoCompleteServiceDataMixin';

export default {
  mixins: [AutoCompleteServiceData],
  methods: {
    onFormSubmit(isEdit, isActive, isDelete, resolve) {
      let errors = [];
      errors = this.checkForm(isEdit);
      this.formData.isActive = isActive;
      if (this.defaultPassword && this.formData.password === this.defaultPassword) {
        delete this.formData.password;
      }
      if (!errors || errors.length === 0) {
        this.$emit('submit-add-edit-form', this.formData, isEdit, isDelete, resolve);
      } else {
        resolve(errors);
      }
    },
    validEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      return re.test(email);
    },
    checkFormSubmission(Constants) {
      this.parseIntegers(Constants);
      return this.checkRequired(Constants);
    },
    checkRequired(Constants) {
      const errors = [];
      Object.values(Constants).forEach(fieldInfo => {
        if (fieldInfo.required && !this.formData[fieldInfo.field] && !this.formData.editMode) {
          errors.push(`${StringHelperService.fieldToTitle(fieldInfo.field)}${FormConstants.Error.RequiredField}`);
        }
      });
      return errors;
    },
    parseIntegers(Constants) {
      Object.values(Constants).forEach(fieldInfo => {
        if (fieldInfo.type && fieldInfo.type === 'number') {
          this.formData[fieldInfo.field] = parseInt(this.formData[fieldInfo.field], 10);
        }
      });
    },
    openDialog(data) {
      this.formData = { ...data };
      if (this.formData.editMode && this.defaultPassword !== undefined) {
        this.formData.password = this.defaultPassword;
      }
      if (this.mappings !== undefined) {
        this.loadMappedAutoCompletes(this.mappings, this.formData);
      }
      this.$refs.addEditForm.openDialog(data);
    }
  }
};
